import type { Route } from '@angular/router';

import { authGuardFn } from '@core/guards/auth.guard';
import { RoleAccessGuard } from '@core/guards/user-role.guard';
import { APP_ROLE } from '@shared/constants/ume-constants';
import { extendedSubAccountsResolver } from '@shared/services/virtual-premium.service';

import { navigationLinkGuardFn } from '../../../layout/guards/navigationLink.guard';
import { VpAccountDetailsComponent } from '../../company-profile/components/vp-account-details/vp-account-details.component';
import { VPAccountsComponent } from './components/company/accounts/vp-accounts.component';
import { CompanyServiceConfigurationPageComponent } from './components/company/company-service-configuration/company-service-configuration.component';
import { CompanyTACPageComponent } from './components/company/company-terms-and-conditions/company-terms-and-conditions.component';
import { CompanyServicesPageComponent } from './components/company/services-page/services-page.component';
import { ServiceConfigurationPageComponent } from './components/provider/service-configuration-page/service-configuration-page.component';
import { ServicesPageComponent } from './components/provider/services-page/services-page.component';
import { MyAccountContainerComponent } from './containers/my-account-container.component';
import {
  companyCurrentServiceResolver,
  companyServicesResolver,
  companyTermsInfoResolver,
  currentServiceResolver,
  servicesResolver,
  serviceTermsAndConditionsResolver,
  termsInfoResolver,
} from './resolvers/services-configuration.resolver';

export const MY_ACCOUNT = 'my-account';

export const SERVICES_ROUTES: Route[] = [
  {
    path: '',
    resolve: {
      services: servicesResolver,
    },
    component: ServicesPageComponent,
  },
  {
    path: ':offeringId/configuration',
    resolve: {
      serviceSetting: currentServiceResolver,
      terms: termsInfoResolver,
    },
    component: ServiceConfigurationPageComponent,
  },
];

export const COMPANY_SERVICES_ROUTES: Route[] = [
  {
    path: '',
    canActivate: [authGuardFn],
    component: MyAccountContainerComponent,
    children: [
      {
        path: 'services',
        canActivate: [navigationLinkGuardFn],
        resolve: {
          services: companyServicesResolver,
        },
        component: CompanyServicesPageComponent,
      },
      {
        path: 'service/:offeringId/configuration',
        resolve: {
          serviceSetting: companyCurrentServiceResolver,
          terms: serviceTermsAndConditionsResolver,
        },
        component: CompanyServiceConfigurationPageComponent,
      },
      {
        path: 'terms-and-conditions',
        canActivate: [navigationLinkGuardFn],
        resolve: {
          terms: companyTermsInfoResolver,
        },
        component: CompanyTACPageComponent,
      },
      {
        path: 'accounts',
        canActivate: [navigationLinkGuardFn],
        resolve: {
          subAccounts: extendedSubAccountsResolver,
        },
        component: VPAccountsComponent,
      },
      {
        path: 'company-details',
        canActivate: [
          RoleAccessGuard.canActivateWithRoles([APP_ROLE.ADMIN, APP_ROLE.EDIT_GENERAL_INFORMATION]),
        ],
        component: VpAccountDetailsComponent,
      },
    ],
  },
];
